
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests/everything-will-be-fine",
      function () {
        return require("private-next-pages/contests/everything-will-be-fine.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests/everything-will-be-fine"])
      });
    }
  